import { render, staticRenderFns } from "./forget-pswd.vue?vue&type=template&id=7a76d0bc&scoped=true&"
import script from "./forget-pswd.vue?vue&type=script&lang=js&"
export * from "./forget-pswd.vue?vue&type=script&lang=js&"
import style0 from "./forget-pswd.vue?vue&type=style&index=0&id=7a76d0bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a76d0bc",
  null
  
)

export default component.exports